import { default as roomReservation } from './room-reservation/routes'
import { default as scheduleActivity } from './schedule-activity/routes'

export default [
    ...roomReservation,
    ...scheduleActivity,
]